export default __webpack_public_path__ + "static/media/dear.20d0bbed.png";